export const USER_CHECK = "/auth/user-check";
export const LOGIN = "/auth/login";
export const FIRST_LOGIN = "/auth/verify-exam-app?user_name=";
export const CHECK_VALID_SYSTEM = "/auth/check-valid-system";export const SESSION = "/auth/session";
